import UserPreferencesDialog from "./UserPreferencesDialog";

export default UserPreferencesDialog;
